import reportService from "services/reportService";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

export const reportRevenue = createAsyncThunk(
    "report/reportRevenue",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.reportRevenue();
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const reportRevenueV2 = createAsyncThunk(
    "report/reportRevenueV2",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.reportRevenueV2(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const reportTimeV2 = createAsyncThunk(
    "report/reportTimeV2",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.reportTimeV2(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const reportTopProduct = createAsyncThunk(
    "report/reportTopProduct",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.reportTopProduct(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const reportStatusOrder = createAsyncThunk(
    "report/reportStatusOrder",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.reportStatusOrder(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const reportTopEmployee = createAsyncThunk(
    "report/reportTopEmployee",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.reportTopEmployee(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const reportChartRevenue = createAsyncThunk(
    "report/reportChartRevenue",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.reportChartRevenue(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const reportAccountRevenue = createAsyncThunk(
    "report/reportAccountRevenue",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.reportAccountRevenue(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const reportAccountChartRevenue = createAsyncThunk(
    "report/reportAccountChartRevenue",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.reportAccountChartRevenue(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

// ===== API mới bổ sung =====

export const reportTypeOrder = createAsyncThunk(
    "report/reportTypeOrder",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.reportTypeOrder(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const reportTimePaymentV2 = createAsyncThunk(
    "report/reportTimePaymentV2",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.reportTimePaymentV2(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const reportRewardV2 = createAsyncThunk(
    "report/reportRewardV2",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.reportRewardV2(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const orderWarehouseReportV2 = createAsyncThunk(
    "report/orderWarehouseReportV2",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.orderWarehouseReportV2(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const cashbookReceiptReport = createAsyncThunk(
    "report/cashbookReceiptReport",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.cashbookReceiptReport(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const warehouseReceiptReportV2 = createAsyncThunk(
    "report/warehouseReceiptReportV2",
    async ({ storeId, isPartnerCurrency }, { rejectWithValue }) => {
        try {
            const response = await reportService.warehouseReceiptReportV2(
                storeId,
                isPartnerCurrency
            );
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const warehouseReportByTime = createAsyncThunk(
    "report/warehouseReportByTime",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.warehouseReportByTime(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const reportChartPartner = createAsyncThunk(
    "report/reportChartPartner",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.reportChartPartner(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const reportChartStoreTotalV2 = createAsyncThunk(
    "report/reportChartStoreTotalV2",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.reportChartStoreTotalV2(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const searchOrderPartner = createAsyncThunk(
    "report/searchOrderPartner",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.searchOrderPartner(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const cashbookReceiptReportPartner = createAsyncThunk(
    "report/cashbookReceiptReportPartner",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.cashbookReceiptReportPartner(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const warehouseReportPartner = createAsyncThunk(
    "report/warehouseReportPartner",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.warehouseReportPartner(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

export const reportChartDiscountStore = createAsyncThunk(
    "report/reportChartDiscountStore",
    async (data, { rejectWithValue }) => {
        try {
            const response = await reportService.reportChartDiscountStore(data);
            return response.data;
        } catch (err) {
            return rejectWithValue(err.message || "Error");
        }
    }
);

const initialState = {
    loading: false,

    warehouseReportByTimeLoading: false,
    reportTopProductLoading: false,
    reportTopEmployeeLoading: false,

    reportRevenueList: [],
    reportTopProductList: [],
    reportStatusOrderList: [],
    reportTopEmployeeList: [],
    reportChartRevenueList: [],
    reportAccountRevenueList: [],
    reportAccountChartRevenueList: [],
    reportRevenueListV2: [],
    reportTimeListV2: [],
    reportTypeOrderList: [],
    reportTimePaymentListV2: [],
    reportRewardListV2: [],
    orderWarehouseReportListV2: [],
    cashbookReceiptReportList: [],
    warehouseReceiptReportListV2: [],
    warehouseReportByTimeList: [],
    reportViolation: [],
    reportChartPartnerList: [],
    searchOrderPartnerList: [],
    cashbookReceiptReportPartnerList: [],
    warehouseReportPartnerList: [],
    reportChartStoreTotalV2List: [],
    reportChartDiscountStoreList: [] 
};

const reportSlice = createSlice({
    name: "report",
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading = true;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(reportRevenue.pending, (state) => {
                state.loading = true;
            })
            .addCase(reportRevenue.fulfilled, (state, action) => {
                state.loading = false;
                state.reportRevenueList = action.payload;
            })
            .addCase(reportRevenue.rejected, (state) => {
                state.loading = false;
            })

            .addCase(reportRevenueV2.pending, (state) => {
                state.loading = true;
            })
            .addCase(reportRevenueV2.fulfilled, (state, action) => {
                state.loading = false;
                state.reportRevenueListV2 = action.payload;
            })
            .addCase(reportRevenueV2.rejected, (state) => {
                state.loading = false;
            })

            .addCase(reportTimeV2.pending, (state) => {
                state.loading = true;
            })
            .addCase(reportTimeV2.fulfilled, (state, action) => {
                state.loading = false;
                state.reportTimeListV2 = action.payload;
            })
            .addCase(reportTimeV2.rejected, (state) => {
                state.loading = false;
            })

            .addCase(reportTopProduct.pending, (state) => {
                state.reportTopProductLoading = true;
            })
            .addCase(reportTopProduct.fulfilled, (state, action) => {
                state.reportTopProductLoading = false;
                state.reportTopProductList = action.payload;
            })
            .addCase(reportTopProduct.rejected, (state) => {
                state.reportTopProductLoading = false;
            })

            .addCase(reportStatusOrder.pending, (state) => {
                state.loading = true;
            })
            .addCase(reportStatusOrder.fulfilled, (state, action) => {
                state.loading = false;
                state.reportStatusOrderList = action.payload;
            })
            .addCase(reportStatusOrder.rejected, (state) => {
                state.loading = false;
            })

            .addCase(reportTopEmployee.pending, (state) => {
                state.reportTopEmployeeLoading = true;
            })
            .addCase(reportTopEmployee.fulfilled, (state, action) => {
                state.reportTopEmployeeLoading = false;
                state.reportTopEmployeeList = action.payload;
            })
            .addCase(reportTopEmployee.rejected, (state) => {
                state.reportTopEmployeeLoading = false;
            })

            .addCase(reportChartRevenue.pending, (state) => {
                state.loading = true;
            })
            .addCase(reportChartRevenue.fulfilled, (state, action) => {
                state.loading = false;
                state.reportChartRevenueList = action.payload;
            })
            .addCase(reportChartRevenue.rejected, (state) => {
                state.loading = false;
            })

            .addCase(reportAccountRevenue.pending, (state) => {
                state.loading = true;
            })
            .addCase(reportAccountRevenue.fulfilled, (state, action) => {
                state.loading = false;
                state.reportAccountRevenueList = action.payload;
            })
            .addCase(reportAccountRevenue.rejected, (state) => {
                state.loading = false;
            })

            .addCase(reportAccountChartRevenue.pending, (state) => {
                state.loading = true;
            })
            .addCase(reportAccountChartRevenue.fulfilled, (state, action) => {
                state.loading = false;
                state.reportAccountChartRevenueList = action.payload;
            })
            .addCase(reportAccountChartRevenue.rejected, (state) => {
                state.loading = false;
            })

            // ===== API mới bổ sung =====
            .addCase(reportTypeOrder.pending, (state) => {
                state.loading = true;
            })
            .addCase(reportTypeOrder.fulfilled, (state, action) => {
                state.loading = false;
                state.reportTypeOrderList = action.payload;
            })
            .addCase(reportTypeOrder.rejected, (state) => {
                state.loading = false;
            })

            .addCase(reportTimePaymentV2.pending, (state) => {
                state.loading = true;
            })
            .addCase(reportTimePaymentV2.fulfilled, (state, action) => {
                state.loading = false;
                state.reportTimePaymentListV2 = action.payload;
            })
            .addCase(reportTimePaymentV2.rejected, (state) => {
                state.loading = false;
            })

            .addCase(reportRewardV2.pending, (state) => {
                state.loading = true;
            })
            .addCase(reportRewardV2.fulfilled, (state, action) => {
                state.loading = false;
                state.reportRewardListV2 = action.payload;
            })
            .addCase(reportRewardV2.rejected, (state) => {
                state.loading = false;
            })

            .addCase(orderWarehouseReportV2.pending, (state) => {
                state.loading = true;
            })
            .addCase(orderWarehouseReportV2.fulfilled, (state, action) => {
                state.loading = false;
                state.orderWarehouseReportListV2 = action.payload;
            })
            .addCase(orderWarehouseReportV2.rejected, (state) => {
                state.loading = false;
            })

            .addCase(cashbookReceiptReport.pending, (state) => {
                state.loading = true;
            })
            .addCase(cashbookReceiptReport.fulfilled, (state, action) => {
                state.loading = false;
                state.cashbookReceiptReportList = action.payload;
            })
            .addCase(cashbookReceiptReport.rejected, (state) => {
                state.loading = false;
            })

            .addCase(warehouseReceiptReportV2.pending, (state) => {
                state.loading = true;
            })
            .addCase(warehouseReceiptReportV2.fulfilled, (state, action) => {
                state.loading = false;
                state.warehouseReceiptReportListV2 = action.payload;
            })
            .addCase(warehouseReceiptReportV2.rejected, (state) => {
                state.loading = false;
            })

            .addCase(warehouseReportByTime.pending, (state) => {
                state.warehouseReportByTimeLoading = true;
            })
            .addCase(warehouseReportByTime.fulfilled, (state, action) => {
                state.warehouseReportByTimeLoading = false;
                state.warehouseReportByTimeList = action.payload;
            })
            .addCase(warehouseReportByTime.rejected, (state) => {
                state.warehouseReportByTimeLoading = false;
            })

            .addCase(reportChartPartner.pending, (state) => {
                state.loading = true;
            })
            .addCase(reportChartPartner.fulfilled, (state, action) => {
                state.loading = false;
                state.reportChartPartnerList = action.payload;
            })
            .addCase(reportChartPartner.rejected, (state) => {
                state.loading = false;
            })
            
            .addCase(reportChartStoreTotalV2.pending, (state) => {
                state.loading = true;
            })
            .addCase(reportChartStoreTotalV2.fulfilled, (state, action) => {
                state.loading = false;
                state.reportChartStoreTotalV2List = action.payload;
            })
            .addCase(reportChartStoreTotalV2.rejected, (state) => {
                state.loading = false;
            })
            
            .addCase(searchOrderPartner.pending, (state) => {
                state.loading = true;
            })
            .addCase(searchOrderPartner.fulfilled, (state, action) => {
                state.loading = false;
                state.searchOrderPartnerList = action.payload;
            })
            .addCase(searchOrderPartner.rejected, (state) => {
                state.loading = false;
            })

            .addCase(cashbookReceiptReportPartner.pending, (state) => {
                state.loading = true;
            })
            .addCase(cashbookReceiptReportPartner.fulfilled, (state, action) => {
                state.loading = false;
                state.cashbookReceiptReportPartnerList = action.payload;
            })
            .addCase(cashbookReceiptReportPartner.rejected, (state) => {
                state.loading = false;
            })

            .addCase(warehouseReportPartner.pending, (state) => {
                state.loading = true;
            })
            .addCase(warehouseReportPartner.fulfilled, (state, action) => {
                state.loading = false;
                state.warehouseReportPartnerList = action.payload;
            })
            .addCase(warehouseReportPartner.rejected, (state) => {
                state.loading = false;
            })
            
            .addCase(reportChartDiscountStore.pending, (state) => {
                state.loading = true;
            })
            .addCase(reportChartDiscountStore.fulfilled, (state, action) => {
                state.loading = false;
                state.reportChartDiscountStoreList = action.payload;
            })
            .addCase(reportChartDiscountStore.rejected, (state) => {
                state.loading = false;
            });
    },
});

export const { showLoading } = reportSlice.actions;

export default reportSlice.reducer;